import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { EventsEffects } from 'src/app/features/social/events/data/state/events.effects';
import { FuelEffects } from 'src/app/features/maintain/fuel/data/state/fuel.effects';
import { MileageEffects } from 'src/app/features/maintain/mileage/data/state/mileage.effects';
import { VanEffects } from 'src/app/features/maintain/vans/data/state/van.effects';
import { PackingListsEffects } from 'src/app/features/plan/packing-lists/data/state/packing-lists.effects';
import { reducers } from './app.reducers';
import { UserEffects } from './user/user.effects';

export function provideAppStore(environment: any) {
  return [
    provideStore(reducers),
    provideEffects([
      UserEffects,
      VanEffects,
      EventsEffects,
      FuelEffects,
      MileageEffects,
      PackingListsEffects,
    ]),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: environment.production,
    }),
  ];
}
